// Group Repository - OOP Pattern (Repository Pattern)
import { IApiClient } from '../interfaces/IApiClient';
import { IGroup, IGroupDetail } from '../interfaces/IGroup';

export class GroupRepository {
  constructor(private apiClient: IApiClient) {}

  async create(data: Omit<IGroup, 'id' | 'createdAt' | 'updatedAt'>): Promise<IGroup> {
    return this.apiClient.post<IGroup>('/groups', data);
  }

  async getAll(): Promise<IGroup[]> {
    return this.apiClient.get<IGroup[]>('/groups');
  }

  async getById(id: string): Promise<IGroupDetail> {
    return this.apiClient.get<IGroupDetail>(`/groups/${id}`);
  }

  async update(id: string, data: Partial<IGroup>): Promise<IGroup> {
    return this.apiClient.put<IGroup>(`/groups/${id}`, data);
  }

  async delete(id: string): Promise<void> {
    return this.apiClient.delete(`/groups/${id}`);
  }

  async addMember(groupId: string, contactId: string): Promise<void> {
    return this.apiClient.post(`/groups/${groupId}/members`, { contactId });
  }

  async removeMember(groupId: string, contactId: string): Promise<void> {
    return this.apiClient.delete(`/groups/${groupId}/members/${contactId}`);
  }
}
